/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class DocumentTypeCountView {
	readonly documentTypeId: number;
	readonly count: number;

	constructor(payload: { readonly documentType: { readonly id: number }; readonly count: number }) {
		this.documentTypeId = payload.documentType.id;
		this.count = payload.count;

		Object.freeze(this);
	}
}

export default DocumentTypeCountView;
